import { http } from "./http";
import { createHolidayCalendar } from "@/utils/usageCalendar";

export const getUsageHolidays = createHolidayCalendar(async (month) => {
  const response = await http.get("/holidays", {
    params: { month },
    timeout: 10000
  });
  return response.data.dates;
});
